import { Component, OnInit, ViewChild } from '@angular/core';
import { AddEditMassComponent } from './add-edit-mass/add-edit-mass.component';
import { MassEditService } from './mass-edit.service';

@Component({
  selector: 'app-mass-edit',
  templateUrl: './mass-edit.component.html',
  styleUrls: ['./mass-edit.component.scss']
})
export class MassEditComponent implements OnInit {

  @ViewChild(AddEditMassComponent) addeditMass: AddEditMassComponent;

  menuItems = [];
  recentItems = [
    { name: "All Edits", code: 'alledits' },
    { name: 'My Edits', code: 'myedits' },
    { name: 'New This week', code: 'newthisweek' },
    { name: 'New Last week', code: 'newlastweek' },
    { name: 'New This month', code: 'newthismonth' },
    { name: 'Recently Viewed Edits', code: 'recentlyviewededits' }
  ];
  selectedRecent;
  globalFilterInput = '';

  selectedView = "list";
  selectedMassEdit;
  configMenuItemsCM = [];
  listCols1 = [
    { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false, move: false },
    { field: 'name', header: 'Route Name', show: true, value: '', checked: false, order: false, move: false }
  ];
  listCols = [
    { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false, move: false },
    { field: 'name', header: 'Route Name', objectNameList: 'name', show: true, value: '', checked: false, order: false, move: false },
    { field: 'territoryName', header: 'Territory', objectNameList: 'territoryname', show: true, value: '', checked: false, order: false, move: false },
    { field: 'routeAssignedTo', header: 'Route Assigned To', objectNameList: 'routeassignedto', show: true, value: '', checked: false, order: false, move: false },
    { field: 'totalDistance', header: 'Total Distance', objectNameList: 'totaldistance', show: true, value: '', checked: false, order: false, move: false },
    { field: 'createdByName', header: 'Created By', objectNameList: 'createdbyname', show: true, value: '', checked: false, order: false, move: false },
    { field: 'createdDate', header: 'Created Date', objectNameList: 'createddate', show: true, value: '', checked: false, order: false, move: false }
  ];
  listColsAll = [
    { field: 'sequenceNumber', header: 'ID No.', show: true, value: '', checked: false, order: false, move: false },
    { field: 'objectName', header: 'Module Name', show: true, value: '', checked: false, order: false, move: false },
    { field: 'executionDate', header: 'Creation Date', show: true, value: '', checked: false, order: false, move: false },
    { field: 'statusId', header: 'Permissions', show: true, value: '', checked: false, order: false, move: false },
    // { field: 'totalDistance', header: 'Total Distance', show: true, value: '', checked: false, order: false, move: false },
    // { field: 'createdByName', header: 'Created By', show: true, value: '', checked: false, order: false, move: false },
    // { field: 'createdDate', header: 'Created Date', show: true, value: '', checked: false, order: false, move: false }
  ];
  // massEditData = [
  //   {
  //     "id":1,
  //     "name":"Name 1",
  //     "territoryName":"Name 1",
  //     "routeAssignedTo":"Name 1",
  //     "totalDistance":"Name 1",
  //     "createdByName":"Name 1",
  //     "createdDate":"Name 1",
  //   },
  //   {
  //     "id":2,
  //     "name":"Name 1",
  //     "territoryName":"Name 1",
  //     "routeAssignedTo":"Name 1",
  //     "totalDistance":"Name 1",
  //     "createdByName":"Name 1",
  //     "createdDate":"Name 1",
  //   },
  // ];
  massEditData:any = [];
  noMEFindOrLoadingText = 'No Mass Edit Found.';
  pageSize: number = 15;

  constructor(
    private massEditService:MassEditService
  ) { }

  ngOnInit(): void {
    this.getMassEditData();
    this.menuItems.push(
      {
        label: 'New',
        icon: 'pi pi-plus',
        command: (event) => this.showAddMassEdit(),
      },
      {
        label: 'Settings',
        icon: 'pi pi-cog ',
        command: (event) => this.settings()
      }
    );
    this.configMenuItemsCM.push(
      {
        label: 'View',
        icon: 'pi pi-list',
        command: () => {
          this.viewMassEdit();
        }
      },
      {
        label: 'Delete',
        icon: 'pi pi-trash',
        command: () => {
        }
      },
      {
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: () => {
          this.editMassEdit();
        }
      }
    );
  }


  getMassEditData(){
    let status:number = 1;              //ask about the status
    this.massEditService.getAllMassEdit(status).subscribe({
      next:(massEditList)=>{
        this.massEditData = massEditList;
        console.log(massEditList);
      }
    })
  }

  showAddMassEdit(){
    this.addeditMass.newMass();
  }
  settings(){

  }
  recentUpdate() {
    
  }
  onGlobalSearch() {
  }
  viewMassEdit(){

  }
  editMassEdit(){

  }
  onRowSelect(event){

  }

}
